import { makeStyles } from '@material-ui/core/styles';

export const useSelectStyle = makeStyles(theme => ({
  select: {
    padding: '5px 8px',
    display: 'inline-flex',
    backgroundColor: theme.palette.common.white,
    height: '30px',
  },
}));

export const useCustomOptionStyle = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.lighter,
      '& > div': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
      },
      '& path': {
        fill: theme.palette.common.white,
      },
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.lightest,
      '& > div': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
      },
      '& path': {
        fill: theme.palette.common.white,
      },
    },
  },
  root: {
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    color: theme.palette.grey[600],
    backgroundColor: theme.palette.grey[100],
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.5,
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: 'calc(100% - 16px)',
    transition: '0.2s',
    transitionProperty: 'color, background-color',
  },
  var: {
    '&::before': {
      content: '"# "',
    },
  },
}));
